module.exports = __webpack_public_path__ + "img/sGolWest_193x205.70739f45.png";